import * as signalR from "@microsoft/signalr";
// export default function Signalr(setSensorDataArray?: any) {
export default function ZetronHub(props: {
    sn?: string,
    setZetronData?: Function
}) {
    const {
        sn,
        setZetronData,
    } = props;
    //TODO
    let connection = new signalR.HubConnectionBuilder().withUrl(`${process.env.REACT_APP_BASE_URL}zetronHub`).build();
    connection.start().then(() => {
        // console.log("started", sn, "ZetronHub");
        connection.invoke("SubscribeToZetronData", sn);
    }).catch((err: any) => {
        return console.error(err.toString());
    });

    connection.on("ReceiveSensorData", (data: any) => {
        // console.log("sn: " + sn + ", data: ", data);
        setZetronData && setZetronData([data]); // Update the data array or object

    });

    return connection
}